import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'numberMaskPipe',
    standalone: false
})
export class NumberMaskPipe implements PipeTransform {
  transform(number: string, visibleDigits: number): string {
    //show number of digits at last based on input
    let maskedNumbers = '****';
    let visibleNumbers = number.slice(-visibleDigits);
    return maskedNumbers + visibleNumbers;
  }
}